/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconGps = createReactComponent("gps", "IconGps", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M12 17l-1 -4l-4 -1l9 -4z", key: "svg-1" }]
]);

export { IconGps as default };
//# sourceMappingURL=IconGps.js.map
